import { useContext } from 'react';

import { SessionContext } from '~components/providers/SessionProvider';

export const useSession = () => {
  const context = useContext(SessionContext);

  if (!context) throw 'Context is undefined. useSession probably not wrapped in Session provider...';

  return context;
};
